class HHSelectBundle extends HTMLElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  connectedCallback() {
    this.select = this.querySelector('select');
    this.message = this.querySelector('[data-element="message"]');
    this.buttons = this.querySelectorAll('hh-button');
    this.select?.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.onChange);
  }

  onChange(e) {
    const { target } = e;
    const selectedOption = [...target.options].find((option) => option.selected);
    if (this.message) {
      this.message.innerHTML = selectedOption.dataset.message ? `<div class="select-bundle__message">${selectedOption.dataset.message}</div>` : '';
    }
    this.buttons.forEach((button) => {
      button.href = e.target.value;
    });
  }
}

if (!customElements.get('hh-select-bundle')) {
  customElements.define('hh-select-bundle', HHSelectBundle);
}
